import request from './index';

export function list(params) {
  return request({
    params,
    method: 'GET',
    path: '/api/admin/scheduler-emails',
  });
}
